import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { GenericComponent } from 'src/app/core/abstracts/generic-component';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { iif, mergeMap, tap } from 'rxjs';
import { UserService } from 'src/app/shared/services/user.service';
import { ProfessionalService } from 'src/app/shared/services/professional.service';
import { UnidadeService } from 'src/app/shared/services/unidade.service';
import { WithdrawalService } from 'src/app/shared/services/withdrawal.service';
import { IWithdrawal } from 'src/app/shared/interfaces/withdrawal/iwithdrawal';
import { MenuItem } from 'primeng/api';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Component({
    selector: 'app-withdraw-modal',
    templateUrl: './withdrawal-modal.component.html',
    styleUrls: ['./withdrawal-modal.component.scss']
})
export class WithdrawalModalComponent extends GenericComponent implements OnInit, OnDestroy {
   
    protected withdrawValue: number | null = null;
    availableForWithdrawal: number = 0;
    withdrawalFee: number = 3.67; //taxa fija da pagarme
    withdrawResult: 'success' | 'error' | null = null;
    errorMessage: string = '';
    bankName: string = '';
    bankBranch: string = '';
    bankAccount: string = '';
    requestedAt: Date = new Date();
    loading = false;
    protocol: string | null = null;
    items: MenuItem[] = [];
    activeIndex: number = 0;
    recipient: string = '';
    externalId = '';

    get isValueValid(): boolean {
        return (
            this.withdrawValue !== null &&
            this.withdrawValue >= 10 &&
            this.withdrawValue <= this.availableForWithdrawal
        );
    }

    get isWithdrawalValid(): boolean {
        return (
            this.isValueValid &&
            this.bankName !== '' &&
            this.bankBranch !== '' &&
            this.bankAccount !== ''
        );
    }

    get amountReceived(): number {
        return this.withdrawValue ? this.withdrawValue - this.withdrawalFee : 0;
    }

    constructor(
        private dynamicDialogRef: DynamicDialogRef,
        private userService: UserService,
        private professionalService: ProfessionalService,
        private unitService: UnidadeService,
        private withdrawalService: WithdrawalService,
        private notifyService: NotifyService
    ) {
        super();
    }

    ngOnInit() {
        this.externalId = 'SAQ_'+crypto.randomUUID();
        this.loadBankAccountData();

        this.items = [
            { label: 'Transfira Seu Saldo Para a Conta Cadastrada' },
            { label: 'Revise os Detalhes' },
            { label: 'Cofirmação' }
        ];        
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    nextStep() {
        if (this.activeIndex < this.items.length - 1) {
            this.activeIndex++;
        }
    }

    previousStep() {
        if (this.activeIndex > 0) {
        this.activeIndex--;
        }
    }

    resetToInitialStep() {
        this.activeIndex = 0;
        this.withdrawValue = null; 
        this.externalId = 'SAQ_'+crypto.randomUUID();
    }

    confirmAndGoToStep3(): void {
        this.loading = true
        let payload:IWithdrawal  = {
            grossAmount: this.withdrawValue ? this.withdrawValue : null,
            externalId: this.externalId
        }
        this.withdrawalService.save(payload).subscribe({
            next: (response) => {
                this.loading = false;
                this.withdrawResult = 'success';
                this.requestedAt = new Date();
                this.protocol = this.externalId;
                this.nextStep();
            },
            error: (err) => {
                this.loading = false;
                this.withdrawResult = 'error';
                this.errorMessage = err.error?.detail ?? err.error?.['hydra:description'] ?? 'Não foi possível realizar o saque.';
                this.nextStep();
            }
        });
    }

    loadBankAccountData() {
        let userId = Number(localStorage.getItem('userId') as string);
        let unitId = Number(localStorage.getItem('unitId') as string);
        let isProfessional: boolean = false;

        this.loading = true;
        this.userService.getbyID(userId).pipe(
            tap((user: any) => {
                isProfessional = user["@type"] === "Professional";
            }),
            mergeMap(() => 
                iif(
                    () => isProfessional,
                    this.professionalService.getById(userId),
                    this.unitService.getById(unitId)
                )
            )
        ).subscribe({
            next: (res: any) => {
                res.taxInfo;
                if (res.taxInfo?.bankAccount) {
                    this.bankName = res.taxInfo.bankAccount.bank.name;
                    this.bankBranch = res.taxInfo.bankAccount.bankBranch;
                    this.bankAccount = res.taxInfo.bankAccount.checkingAccount;
                }
                
                this.recipient = res.taxInfo.recipient;
                this.loading = false;
            },
            error: () => {
                this.notifyService.emitError('Erro ao carregar informações bancárias.');
                this.loading = false;
            }
        });     
    }

    onAvailableForWithdrawalChange(availableAmount: number) {
        this.availableForWithdrawal = availableAmount;
    }

    close() {
        this.dynamicDialogRef.close();
    }
}
